import React, { Component } from 'react'

import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import PageWrapper from '../../components/PageWrapper'
import BorderButton from '../../components/BorderButton'
import { Preloader } from '../../components/Chart/index'
import WhiteBox from '../../components/WhiteBox'
import './styles.css'
import axios from 'axios'

class EditAudience extends Component {
    state = {
        name: '',
        selected: {},
        stsegments: 'vertical',
        disableButton: true,
        saving: false,
        audienceId: '',
        audienceName: '',
        description: '',
        alternativeId: ''
    }

    constructor(props) {
        super(props)

        console.log('EDIT ', this.props.location.state.audience)

        this.state = {
            audienceId: this.props.location.state.audience.audienceId,
            audienceName: this.props.location.state.audience.audienceName,
            description: this.props.location.state.audience.description,
            alternativeId: this.props.location.state.audience.alternativeId
        }
    }

    onChange = (segment, value) =>
        this.setState(state => ({
            segments: [...state.segments, segment]
        }))

    onCancel = () => this.props.goBack()
    onSave = () => {
        if (this.state.audienceName) {
            this.setState({ disableButton: true, saving: true }, () => {
                /*console.log('on edit', this.props.audience, this.state.audienceName)
                //this.props.editAudience(this.state.audienceName, this.props.audience.audienceId)
                this.props.history.push(
                    '/audiences/import?audienceId=' +
                        this.props.audience.audienceId +
                        '&audienceName=' +
                        encodeURIComponent(this.state.audienceName) +
                        '&description=' +
                        encodeURIComponent(this.state.description)
                )*/

                const body = {
                    audienceId: this.state.audienceId,
                    alternativeId: this.state.alternativeId,
                    description: this.state.description
                }
                // if new
                let method = 'PATCH'
                axios
                    .request({ url: '/audience', method: method, data: body })
                    .then(response => {
                        console.log('successfully saved a new audience!', response)
                        this.props.history.push('/audiences')
                    })
                    .catch(err => {
                        this.setState({ saving: false })
                    })
            })
        }
    }

    render() {
        return (
            <PageWrapper>
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-10">
                            <WhiteBox>
                                <div
                                    style={{
                                        position: 'relative',
                                        paddingRight: 100
                                    }}>
                                    <div className="row">
                                        <div className="col-3">
                                            <img src="/img/audience/illy-segment-based-audience.svg" alt="" />
                                        </div>
                                        <div className="col-9">
                                            <h3 style={{ marginTop: 26 }}>EDIT AUDIENCE</h3>

                                            <p style={{ marginTop: 30 }}>Audience Name</p>
                                            <input
                                                type="text"
                                                className="form-control"
                                                disabled={true}
                                                value={this.state.audienceName}
                                                onChange={({ target }) => this.setState({ audienceName: target.value, disableButton: target.value == '' })}
                                            />

                                            <p style={{ marginTop: 30 }}>Description</p>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={this.state.description}
                                                onChange={({ target }) => this.setState({ description: target.value, disableButton: target.value == '' })}
                                            />

                                            <p style={{ marginTop: 30 }}>Alternative ID</p>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={this.state.alternativeId}
                                                onChange={({ target }) => this.setState({ alternativeId: target.value, disableButton: target.value == '' })}
                                            />

                                            <div className="new-segment-based-audience new-segment-based-audience--button-group">
                                                <BorderButton className="grey" label="Cancel" onClick={this.onCancel} />
                                                <BorderButton label="SAVE" onClick={this.onSave.bind(this)} />
                                                {this.state.saving && <Preloader transparent />}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </WhiteBox>
                        </div>
                    </div>
                </div>
            </PageWrapper>
        )
    }
}

export default connect(
    state => ({}),
    {
        goBack: () => push('/audiences')
    }
)(EditAudience)
